import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, filterVAutocomplete } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "ScheduledCommissionsModal",
  props: {
    listUserGroup: {
      type: Array,
      default: []
    },
    listUsers: {
      type: Array,
      default: []
    },
    listConsultants: {
      type: Array,
      default: []
    },
    listCountries: {
      type: Array,
      default: []
    },
    listWineries: {
      type: Array,
      default: []
    },
    listWines: {
      type: Array,
      default: []
    },
    initFormValues: {
      type: Object,
      default: null
    }
  },
  components: {
    Confirm: Confirm
  },
  data: function data(_this) {
    return {
      shown: false,
      isLoading: false,
      isAdding: false,
      isDeletingAll: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      openedPanels: [0],
      now: new Date(),
      minDate: moment().add(1, "days").toDate().formatForDatePickerDays(),
      scheduledModifications: [],
      form: {
        futurePercentageFee: null,
        scheduledApplicationDate: moment().add(1, "months").startOf("month").toDate().formatForDatePickerDays(),
        userGroup: null,
        userId: null,
        consultantId: null,
        countryIds: [],
        wineryIds: [],
        wineIds: []
      },
      managedExceptions: {
        warning: {
          conflict_date: "There is already a scheduled commission for this configuration."
        }
      },
      addDateMenu: null,
      futureHeaders: [{
        text: "Scheduled date",
        value: "scheduledApplicationDate",
        align: "left"
      }, {
        text: "Group / User / Consultant",
        value: "userGroup",
        align: "left"
      }, {
        text: "Country",
        value: "country",
        align: "left"
      }, {
        text: "Producer",
        value: "winery",
        align: "left"
      }, {
        text: "Product",
        value: "wine",
        align: "left"
      }, {
        text: "Future Commission (%)",
        value: "futurePercentageFee",
        align: "left"
      }, {
        text: "",
        value: "action",
        align: "right"
      }],
      previousHeaders: [{
        text: "Application date",
        value: "actualApplicationDate",
        align: "left"
      }, {
        text: "Group / User / Consultant",
        value: "userGroup",
        align: "left"
      }, {
        text: "Country",
        value: "country",
        align: "left"
      }, {
        text: "Producer",
        value: "winery",
        align: "left"
      }, {
        text: "Product",
        value: "wine",
        align: "left"
      }, {
        text: "Commission (€)",
        value: "futurePercentageFee",
        align: "left"
      }],
      rules: formRules
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isAdding || this.isDeleting || this.isDeletingAll;
    },
    isInvalidForm: function isInvalidForm() {
      return !this.form.futurePercentageFee || this.form.scheduledApplicationDate <= this.now;
    },
    futureScheduledModifications: function futureScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return !x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(a.scheduledApplicationDate) - new Date(b.scheduledApplicationDate);
      });
    },
    previousScheduledModifications: function previousScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(b.scheduledApplicationDate) - new Date(a.scheduledApplicationDate);
      });
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.initFormValues) {
              _this2.form = _objectSpread(_objectSpread({}, _this2.form), _this2.initFormValues);
            }
            _context.next = 3;
            return _this2.getScheduledModifications();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    getScheduledModifications: function getScheduledModifications() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/scheduled-commissions/", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load scheduled modifications.", {
                  type: "error"
                });
                _this3.isLoading = false;
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this3.scheduledModifications = _toConsumableArray(response.data.value);
              _this3.isLoading = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$form, countryIds, wineryIds, wineIds, hasCountryIds, _iterator, _step, countryId;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isAdding = true;
              _this4$form = _this4.form, countryIds = _this4$form.countryIds, wineryIds = _this4$form.wineryIds, wineIds = _this4$form.wineIds;
              hasCountryIds = countryIds.length > 0;
              if (!hasCountryIds) {
                _context3.next = 23;
                break;
              }
              _iterator = _createForOfIteratorHelper(countryIds);
              _context3.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context3.next = 13;
                break;
              }
              countryId = _step.value;
              _context3.next = 11;
              return _this4.addScheduledModifications(countryId, wineryIds, wineIds);
            case 11:
              _context3.next = 7;
              break;
            case 13:
              _context3.next = 18;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](5);
              _iterator.e(_context3.t0);
            case 18:
              _context3.prev = 18;
              _iterator.f();
              return _context3.finish(18);
            case 21:
              _context3.next = 25;
              break;
            case 23:
              _context3.next = 25;
              return _this4.addScheduledModifications(null, wineryIds, wineIds);
            case 25:
              _context3.next = 27;
              return _this4.getScheduledModifications();
            case 27:
              _this4.isAdding = false;
              _this4.$toasted.show("Scheduled modification(s) added.", {
                type: "success"
              });
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[5, 15, 18, 21]]);
      }))();
    },
    addScheduledModifications: function addScheduledModifications(countryId, wineryIds, wineIds) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var hasWineryIds, hasWineIds, promises;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              hasWineryIds = wineryIds.length > 0;
              hasWineIds = wineIds.length > 0;
              promises = [];
              if (hasWineryIds) {
                promises = wineryIds.map(function (wineryId) {
                  return _this5.addScheduledModification(countryId, wineryId, null);
                });
              } else if (hasWineIds) {
                promises = wineIds.map(function (wineId) {
                  return _this5.addScheduledModification(countryId, null, wineId);
                });
              } else {
                promises = [_this5.addScheduledModification(countryId, null, null)];
              }
              _context4.next = 6;
              return Promise.all(promises);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    addScheduledModification: function addScheduledModification(countryId, wineryId, wineId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              data = {
                futurePercentageFee: _this6.form.futurePercentageFee,
                scheduledApplicationDate: _this6.form.scheduledApplicationDate,
                userGroup: _this6.form.userGroup,
                userId: _this6.form.userId,
                consultantId: _this6.form.consultantId,
                countryId: countryId,
                wineryId: wineryId,
                wineId: wineId
              };
              _this = _this6;
              _context5.next = 4;
              return request("/v1/scheduled-commissions", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to add a scheduled modification.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    confirmCancelScheduledModification: function confirmCancelScheduledModification(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this7.$refs.confirm.open("Delete", "Are you sure you want to cancel this scheduled modification ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(confirm) {
                  var _this;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!confirm) {
                          _context6.next = 6;
                          break;
                        }
                        _this = _this7;
                        _context6.next = 4;
                        return _this7.cancelScheduledModification(item).catch(function (e) {
                          var errorData = getErrorData(e, _this.managedExceptions, "Unable to cancel scheduled modification.");
                          _this.$toasted.show(errorData.message, {
                            type: errorData.type
                          });
                        });
                      case 4:
                        _this7.getScheduledModifications();
                        _this7.$toasted.show("Scheduled modification cancelled.", {
                          type: "success"
                        });
                      case 6:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    cancelScheduledModification: function cancelScheduledModification(item) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              item.isDeleting = true;
              _context8.next = 3;
              return request("/v1/scheduled-commissions/" + item.id, "delete", null, true, "api").catch(function (e) {
                item.isDeleting = false;
                throw e;
              });
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    confirmCancelAllFutureModifications: function confirmCancelAllFutureModifications() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this8.$refs.confirm.open("Delete", "Are you sure you want to cancel all scheduled modifications ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(confirm) {
                  var nbErrors, promises;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        if (!confirm) {
                          _context9.next = 7;
                          break;
                        }
                        _this8.isDeletingAll = true;
                        nbErrors = 0;
                        promises = _this8.futureScheduledModifications.map(function (item) {
                          return _this8.cancelScheduledModification(item).catch(function () {
                            nbErrors++;
                          });
                        });
                        _context9.next = 6;
                        return Promise.all(promises);
                      case 6:
                        if (nbErrors == _this8.futureScheduledModifications.length) {
                          _this8.$toasted.show("Unable to cancel any scheduled modification(s).", {
                            type: "error"
                          });
                        } else if (nbErrors > 0) {
                          _this8.$toasted.show("Unable to cancel ".concat(nbErrors, " scheduled modification(s)."), {
                            type: "warning"
                          });
                          _this8.getScheduledModifications();
                        } else {
                          _this8.getScheduledModifications();
                          _this8.$toasted.show("Scheduled modification cancelled.", {
                            type: "success"
                          });
                        }
                      case 7:
                        _this8.isDeletingAll = false;
                      case 8:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete
  }
};